import React from 'react';
import PropTypes from 'prop-types';
import Container from '../PageBuilder/lib/Container';

const HTMLText = ({ text }) => <div dangerouslySetInnerHTML={{__html: text}} />

const TextBoxWidget = ({ text, dropcap, containerSettings }) => (
  <Container className="text-box" settings={containerSettings}>
    <div className="container">
      <div className="shift-two-cols">
        <div className={`text-wrapper ${dropcap === 'no' ? '' : 'dropcap'}`}>
          <HTMLText text={text} />
        </div>
      </div>
    </div>
  </Container>
);

TextBoxWidget.title = 'Text';
TextBoxWidget.preview = 'text.png';
TextBoxWidget.category = 'Content';
TextBoxWidget.dialogSize = 'large';

TextBoxWidget.propTypes = {
  text: PropTypes.string.isRequired,
  dropcap: PropTypes.string.isRequired,
  containerSettings: PropTypes.object.isRequired,
};

TextBoxWidget.defaults = {
  text: 'Не можеш да строиш къща без гвоздеи и дървен материал. Ако не искаш къщата да бъде построена — скрий гвоздеите и дървения материал. Ако не искаш човек да се вълнува от политиката, не му разказвай двете страни на даден въпрос, за да не го тревожиш — разкрий му само едната. А най-добре не му казвай нищо. Нека изобщо забрави, че съществува нещо, което се нарича война. Ако правителството е некомпетентно, бюрократично или пък налага прекомерни данъци, това все пак е по-добре, отколкото да се тревожи народът. Спокойствие, Монтег. Предлагай на хората конкурси, които могат да спечелят, ако си спомнят думите на колкото се може повече популярни песни или имената на колкото се може повече столици на щати, или пък колко царевица е произвел щатът Айова миналата година. Набий в главите им безобидни данни, натъпчи ги с толкова много „факти“, че да се задушат от тях, като същевременно се смятат за „много умни“ поради това, което знаят. Тогава те ще имат чувството, че мислят, че се движат, без всъщност да са се помръднали. И ще бъдат щастливи, защото фактите от този род не се променят. Не ги храни с такива неразбираеми неща като философия или социология, от които да започнат да правят обобщения. Това води до меланхолия. Всеки човек, който може да разглоби една телевизионна стена и след това отново да я сглоби — а сега повечето хора умеят това, — е по-щастлив, отколкото онзи, който се опитва да открие измеренията на вселената и да я прецени, защото вселената не може да бъде измерена или преценена, без човек да се почувствува нищожен и самотен. Зная, опитвал съм го — по дяволите всичко! Затова дайте ни клубове, увеселения, акробати и фокусници, авантюристи, реактивни коли, мотоциклети-хеликоптери, порнография и наркотици, давайте ни все повече и повече от всичко, което има връзка с автоматичните рефлекси. И ако фабулата е лоша, ако във филма не се казва нищо, ако артистите са бездарни, инжектирай ме с оглушителна електронна музика. Тогава ще имам чувството, че реагирам на пиесата, а всъщност това ще бъде само реакция на органите на осезанието ми към вибрацията. Но аз пет пари не давам, търся само да се забавлявам.',
  dropcap: 'no',
  containerSettings: {},
};

TextBoxWidget.adminFields = {
  text: { type: 'rich' },
  dropcap: { type: 'select', options: [['no', 'No'], ['yes', 'Yes']] },
};

export default TextBoxWidget;
